function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, Image, TouchableOpacity, ImageBackground, StatusBar, StyleSheet } from 'react-native';
import { getStatusBarHeight, getPaddingFromStatusBar } from '../../constants';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
import Badge, { BadgeType } from '../Badge';
import { headerBackground, iconNotification } from '../../assets';
import { increasedTapZone } from '../../common';
export let HeaderType;

(function (HeaderType) {
  HeaderType["Default"] = "default";
  HeaderType["Transparent"] = "transparent";
  HeaderType["Warning"] = "warning";
})(HeaderType || (HeaderType = {}));

const Header = _ref => {
  let {
    leftComponent,
    rightComponent,
    notificationComponent,
    type = HeaderType.Default,
    titleAccessibility,
    title,
    translucent,
    barStyle = 'light-content',
    theme: {
      colors
    },
    transparentColor,
    defaultBackgroundImage,
    warningBackgroundImage
  } = _ref;

  const topButtonsView = () => {
    return /*#__PURE__*/React.createElement(View, {
      style: styles.topButtonsView
    }, leftComponent && /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, increasedTapZone(), {
      accessibilityRole: 'button'
    }, leftComponent.accessibility, {
      style: styles.leftComponentButton,
      onPress: leftComponent === null || leftComponent === void 0 ? void 0 : leftComponent.action
    }), leftComponent === null || leftComponent === void 0 ? void 0 : leftComponent.icon, /*#__PURE__*/React.createElement(Text, {
      type: TextType.OverlineBold,
      color: colors.text.ondark
    }, leftComponent === null || leftComponent === void 0 ? void 0 : leftComponent.name)), /*#__PURE__*/React.createElement(View, {
      style: styles.rightComponentButton
    }, rightComponents()));
  };

  const rightComponents = () => {
    return /*#__PURE__*/React.createElement(View, {
      style: styles.rightComponentsView
    }, notificationComponent && /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      accessibilityRole: 'button'
    }, increasedTapZone(), notificationComponent.accessibility, {
      onPress: notificationComponent === null || notificationComponent === void 0 ? void 0 : notificationComponent.action
    }), /*#__PURE__*/React.createElement(Image, {
      source: iconNotification,
      style: styles.image
    }), !!(notificationComponent !== null && notificationComponent !== void 0 && notificationComponent.badgeCount) && /*#__PURE__*/React.createElement(View, {
      style: styles.badgeView
    }, /*#__PURE__*/React.createElement(Badge, {
      type: BadgeType.Critical,
      value: notificationComponent === null || notificationComponent === void 0 ? void 0 : notificationComponent.badgeCount
    }))), (rightComponent === null || rightComponent === void 0 ? void 0 : rightComponent.icon) && /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      accessibilityRole: 'button'
    }, increasedTapZone(), {
      style: notificationComponent ? styles.rightComponent : styles.rightComponentCompact
    }, rightComponent.accessibility, {
      onPress: rightComponent === null || rightComponent === void 0 ? void 0 : rightComponent.action
    }), rightComponent === null || rightComponent === void 0 ? void 0 : rightComponent.icon));
  };

  const getBackgroundColor = () => {
    switch (type) {
      case HeaderType.Transparent:
        return transparentColor || 'transparent';

      case HeaderType.Warning:
        return colors.background.warning;

      case HeaderType.Default:
      default:
        return colors.background.header;
    }
  };

  const style = [styles.container, {
    backgroundColor: getBackgroundColor()
  }];
  const customBackground = type === HeaderType.Default ? defaultBackgroundImage : warningBackgroundImage;
  const backgroundImage = customBackground || headerBackground;
  return /*#__PURE__*/React.createElement(ImageBackground, {
    style: style,
    source: type === HeaderType.Transparent ? null : backgroundImage
  }, /*#__PURE__*/React.createElement(StatusBar, {
    barStyle: barStyle,
    translucent: translucent
  }), leftComponent && topButtonsView(), /*#__PURE__*/React.createElement(View, {
    style: styles.titleView
  }, !!title && title.length > 0 && /*#__PURE__*/React.createElement(View, {
    style: [styles.titleTextContainer, leftComponent && styles.titleTextWithLeftComponent]
  }, /*#__PURE__*/React.createElement(Text, _extends({}, titleAccessibility, {
    type: TextType.Headline2,
    color: colors.text.ondark
  }), title)), !leftComponent && rightComponents()));
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingTop: getStatusBarHeight() + getPaddingFromStatusBar()
  },
  topButtonsView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 24
  },
  titleView: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    minHeight: 20,
    paddingBottom: 16
  },
  titleTextContainer: {
    flex: 1,
    paddingTop: 0
  },
  titleTextWithLeftComponent: {
    paddingTop: 20
  },
  leftComponentButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    marginLeft: 24
  },
  rightComponentButton: {
    paddingRight: 24
  },
  rightComponentsView: {
    flexDirection: 'row',
    height: '100%'
  },
  rightComponent: {
    marginLeft: 24
  },
  rightComponentCompact: {
    paddingLeft: 8
  },
  image: {
    width: 24,
    height: 24,
    resizeMode: 'contain'
  },
  badgeView: {
    position: 'absolute',
    right: -5,
    top: -5
  }
});
export default withTheme(Header);
//# sourceMappingURL=index.js.map